import * as React from "react"

import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../lib/utils"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement>, VariantProps<typeof inputVariants> {
  startEnhancer?: React.ReactNode
} 

const inputVariants = cva(
  "relative bg-white border rounded-md h-10 flex items-center text-sm",
  {
    variants: {
      variant: {
        default: "",
        dark: "bg-slate-300"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
)

const Input = React.forwardRef<HTMLInputElement, InputProps>(
({ startEnhancer, variant, className, type, ...props }, ref) => {
  return (
    <div className={cn(inputVariants({ variant, className }))}>
      {startEnhancer && (
        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
          {startEnhancer}
        </div>
      )}
    <input
      style={{fontSize:'inherit'}}
      type={type}
      className={cn(
        "flex w-full bg-transparent px-3 py-2 text-sm ring-offset-background rounded-[inherit] font-[inherit] text-[inherit] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        startEnhancer ? "pl-9" : "", // Add left padding if startEnhancer exists
        
      )}
      ref={ref}
      {...props}
    />
    </div>
  )
}
)
Input.displayName = "Input"

export { Input }
